// extracted by mini-css-extract-plugin
module.exports = {"Loading":"bbr_a bgu_a bgu_w bgu_j bgu_tf bgu_tg bgu_fg"};